import { combineReducers } from "@reduxjs/toolkit";

import { setupAccReducer } from "./SetupAccountSlice";

export const setupAccountReducer = combineReducers({
  setupAccount: setupAccReducer,
});
